import React, { useCallback } from 'react'
import MarkdownRender from 'LuxKit/MarkdownRender'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import FlashHotelAvailabilityButton from '../FlashHotelAvailabilityButton'
import OfferPageIntroInclusions from 'components/OfferPage/OfferPageIntroInclusions'
import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import { useIntl } from 'react-intl'

interface Props {
  additionalDescriptionMarkdown: string
  highlightsMarkdown: string
  tileInclusions?: Array<App.OfferInclusion>
}

function FlashHotelInclusionsAndHighlightsModal(props: Props) {
  const {
    additionalDescriptionMarkdown,
    highlightsMarkdown,
    tileInclusions,
  } = props

  const intl = useIntl()
  const { resolve } = useModalElementContext()
  const onCTAClick = useCallback(() => resolve(), [resolve])

  return (
    <ModalBase>
      <ModalHeader
        title={intl.formatMessage({
          id: 'qy89CfHT2y',
          defaultMessage: 'Inclusions & Highlights',
          description: 'Title for inclusions and highlights modal',
        })}
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            { tileInclusions && <>
              <Group direction="vertical" gap={8}>
                <HeadingTextBlock variant="heading4">
                  {intl.formatMessage({
                    id: 'mBAWH5kpcv',
                    defaultMessage: 'Your handpicked inclusions',
                    description: 'Heading for handpicked inclusions',
                  })}
                </HeadingTextBlock>
                <OfferPageIntroInclusions tileInclusionsList={tileInclusions} />
              </Group>
              <Divider kind="secondary" />
            </>}
            <MarkdownRender type="compact" content={additionalDescriptionMarkdown} />
            <Divider kind="secondary" />
            <HeadingTextBlock variant="heading4">
              {intl.formatMessage({
                id: 'ZCmRlp1dIP',
                defaultMessage: 'Highlights',
                description: 'Heading for highlights section',
              })}
            </HeadingTextBlock>
            <MarkdownRender type="compact" fontSize="large" content={highlightsMarkdown} />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <SoftOfferPageWalledGarden>
        <ModalFooter>
          <FlashHotelAvailabilityButton onClick={onCTAClick} />
        </ModalFooter>
      </SoftOfferPageWalledGarden>
    </ModalBase>
  )
}

export default FlashHotelInclusionsAndHighlightsModal
